<template>
    <div :id="id" class="map" ref="nedglobeMiniMapElement"></div>
</template>

<script>
    import { defaults as OlDefaultInteractions } from 'ol/interaction';

    export default {
        props: {
            id: { type: String, required: true },
            center: { type: Array, required: false },
            showControls: { type: Boolean, required: false, default: true }
        },
        components: {},

        data() {
            return {};
        },

        async mounted() {
            this.init();
        },

        methods: {
            async init() {
                this.$store.commit('REGISTER_MAP', {
                    name: this.id,
                    id: this.id,
                    interactions: new OlDefaultInteractions({
                        altShiftDragRotate: false,
                        pinchRotate: false,
                        doubleClickZoom: false,
                        keyboard: false,
                        mouseWheelZoom: true,
                        shiftDragZoom: false,
                        dragPan: true,
                        pinchZoom: false
                    }),
                    controls: !this.showControls ? [] : undefined
                });
                const mapConfig = this.$store.state.maps.find(
                    (_map) => _map.name === this.id
                );
                if (this.center) {
                    mapConfig.map.getView().setCenter(this.center);
                }
                const firstbaselayer = this.$store.getters.getBaseLayers[0];
                await this.$store.dispatch('addLayerToMap', {
                    mapName: this.id,
                    id: firstbaselayer.id
                });
                this.listenToMap(mapConfig);
                const { width, height } =
                    this.$refs.nedglobeMiniMapElement.getBoundingClientRect();
                mapConfig.map.setSize([width, height]);
            },
            listenToMap(mapConfig) {
                const map = mapConfig.map;

                map.once('postrender', () => {
                    map.on('click', (evt) => {
                        this.$emit('click', evt);
                    });
                    map.on('click', (evt) => {
                        this.$emit('click', evt.pixel);
                    });
                    map.on('pointermove', (evt) => {
                        if (evt.dragging) {
                            return;
                        }
                        const pixel = map.getEventPixel(evt.originalEvent);
                        this.$emit('hover', pixel);
                    });
                });
            },
            addCustomLayer(olLayer) {
                const mapConfig = this.$store.state.maps.find(
                    (_map) => _map.name === this.id
                );
                mapConfig.map.addLayer(olLayer);
            }
        }
    };
</script>

